import { render, staticRenderFns } from "./BankStatementTable.vue?vue&type=template&id=03052c18"
import script from "./BankStatementTable.vue?vue&type=script&lang=js"
export * from "./BankStatementTable.vue?vue&type=script&lang=js"
import style0 from "./BankStatementTable.vue?vue&type=style&index=0&id=03052c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports